import { Component, OnInit } from '@angular/core'
import { ActivatedRoute, Params, Router } from '@angular/router'
import { ExpertGroupPortal } from 'src/app/shared/interfaces/expert-group-portal.interface'
import { Page } from 'src/app/shared/interfaces/page.interface'
import { Area } from 'src/app/shared/interfaces/resources/area.interface'
import { StripHtmlPipe } from 'src/app/shared/pipes/strip-html.pipe'
import { AreaService } from 'src/app/shared/services/area.service'
import { MetaService } from 'src/app/shared/services/meta.service'
import { PageService } from 'src/app/shared/services/page-service/page.service'
import { ExpertGroupPortalService } from '../../services/expert-group-portal.service'

@Component({
  selector: 'app-expert-group-portal-data',
  templateUrl: './expert-group-portal-data.component.html',
  styleUrls: ['./expert-group-portal-data.component.scss']
})
export class ExpertGroupPortalDataComponent implements OnInit {
  page: Page
  area: Area

  loader = true
  hasData = false

  baseUrl: string
  expertGroupPortal: ExpertGroupPortal
  selectedVisualizationFiltersHash: string

  constructor(
    private pageService: PageService,
    private areaService: AreaService,
    private stripHtmlPipe: StripHtmlPipe,
    private metaService: MetaService,
    private router: Router,
    private expertGroupPortalService: ExpertGroupPortalService,
    private activatedRoute: ActivatedRoute
  ) {}

  async ngOnInit() {
    this.activatedRoute.queryParams.subscribe(async (queryParams: Params) => {
      // Get the current expert group portal without the query params
      this.baseUrl = this.router.url.split('?')[0]

      // The id of the current expert group portal, it's always one string before the last slash
      const id: string = this.baseUrl.split('/').slice(-2)[0]

      this.expertGroupPortal =
        this.expertGroupPortalService.getExpertGroupPortalById(id)

      this.page = await this.pageService.show(
        this.expertGroupPortal.slug + '-data'
      )

      this.area = await this.areaService.show(
        this.expertGroupPortal.slug + '-data'
      )

      this.metaService.setTags({
        title: this.page.metaTitle || this.page.title,
        description: this.stripHtmlPipe.transform(
          this.page.metaDescription || this.page.excerpt
        ),
        path: id + '/data',
        absoluteOgImage: this.page.image
          ? this.page.image.socialCard
          : this.metaService.defaultMeta.absoluteOgImage
      })

      this.selectedVisualizationFiltersHash =
        queryParams.visualizationFiltersHash
    })
  }
}
